<template>
  <div :class="$style.button" @click="setActiveModal('Main')">
    Find Your Size
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  methods: mapMutations(['setActiveModal'])
}
</script>

<style lang="scss" module>
.button {
  position: relative;
  top: 2px;
  bottom: 10px;
  display: inline-block;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  transition: .2s;
  font-weight: bold;
  color: black;
  text-decoration: underline;

  &:hover {
  
    color: rgb(0, 0, 0);
  }
}
</style>
